import styled from 'styled-components';

interface BtnContatoProps {
  isActive: boolean;
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  form {
    width: 100%
  }

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;

  h3 {
    width: 380px;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    text-align: center;
    color: ${props => props.theme.colors.mainColor}
  }

  > h3 {
    width: 85%;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 10px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  div.resume {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 0 30px;
    width: 100%;


    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: left;
      margin: 0 10px;
      width: 100%
    }

    span,
    p {
      width: 100%;
      font-size: 22px;
      font-weight: 600;
    }

    span {
      color: ${props => props.theme.colors.mainColor};
    }

    small {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 16px;
      width: 100%;
      color: ${props => props.theme.colors.grey02};

      svg {
        cursor: pointer;
        margin-left: 8px;
        color: ${props => props.theme.colors.warning};
        z-index: 99;
      }
    }

  @media screen and (max-width: 700px) {
    padding: 0 5px;

    div.date {
      width: 70%;
    }
  }


    /* small#month-value {
      font-size: 16px;
      font-weight:600;
      color: ${props => props.theme.colors.greyDarker};
    }

    small {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 16px;
      color: ${props => props.theme.colors.grey02};

      svg {
        cursor: pointer;
        margin-left: 8px;
        color: ${props => props.theme.colors.warning}
      }
    }

    span, p {
      width: 110px;
      font-size: 16px;
      font-weight: 600;
      color: ${props => props.theme.colors.mainColor};
    }

    span {
      font-size: 24px;
    } */
  }
`

export const BoxValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  border: 1px solid #F4F4F4;
  padding: 8px 20px;
  margin: 4px;
`

export const RadioButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 100%;
  padding: 12px;
  margin-bottom: 10px;

  background: #FFF;
  border-radius: 4px;
  border: 1px solid #F4F6F5;
  box-shadow: 0px 2px 4px rgba(61, 69, 67, 0.05);

  h3 {
    font-size: 16px;
    text-align: start;
    color: ${props => props.theme.colors.greyDarker};
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
  }

  > input {
    width: 300px;
    border: none;
    margin: 12px 0 0;
    color: ${props => props.theme.colors.mainColor};
  }

  > button {
    background-color: transparent;
    border: none;
    margin-bottom: 10px;
    color: ${props => props.theme.colors.greyDarker};
    font-weight: 600;
    transition: all .3s ease;
    display: flex;
    align-items: center;

    > svg {
      margin-left: 8px;
      color: ${props => props.theme.colors.warning};
    }

    &:hover {
      color: ${props => props.theme.colors.mainColor};
      transition: all .3s ease;
    }
  }

  div#terms {
    .switch {
      margin: 0 15px;
    }

    small {
      width: 90%;
      color: ${props => props.theme.colors.grey02};
    }
  }

  @media screen and (max-width: 700px) {
    padding: 10px 8px;

    > div {
      justify-content: space-evenly;
    }
  }
`

export const BtnContato = styled.button<BtnContatoProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 150px;
  height: 40px;

  background-color: #FFF;
  color: ${props => props.isActive ? props.theme.colors.mainColor : '#3D4543'};
  font-weight: 600;

  border-radius: 4px;
  border: 1px solid ${props => props.isActive ? props.theme.colors.mainColor : '#DEE3E1'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
`

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 100%;
  padding: 12px;
  margin-bottom: 10px;

  background: #FFF;
  border-radius: 4px;
  border: 1px solid #F4F6F5;
  box-shadow: 0px 2px 4px rgba(61, 69, 67, 0.05);

  h3 {
    font-size: 18px;
    margin-bottom: 5px;
    text-align: start;
    color: ${props => props.theme.colors.mainColor};
  }

  div {
    width: 100%;

    p {
      font-weight: 550;
      margin: 5px 0;
    }

    small {
      font-size: 14px;
      color: ${props => props.theme.colors.grey02};
    }
  }

  div.dependents {
    padding: 0 15px;
    margin-bottom: 20px;

    p {
      font-weight: 550;
      margin: 3px 0;
    }
  }
`



